import React from 'react';
import { Clapperboard } from 'lucide-react';
import { reelsAPI } from '../../lib/api';
import MediaContentManager, { youtubeId, youtubeThumb } from '../../components/admin/MediaContentManager';

const config = {
  title: 'Reels',
  description: 'Short videos for the Reels tab and Watch section on the website and in the apps.',
  noun: 'reel',
  icon: Clapperboard,
  api: reelsAPI,
  thumbnail: (r) => youtubeThumb(r.youtube_url),
  subtitle: (r) => [r.source, r.category].filter(Boolean).join(' · '),
  fields: [
    { name: 'title', label: 'Title', required: true, placeholder: 'What happened in 60 seconds' },
    {
      name: 'youtube_url', label: 'YouTube link', required: true, placeholder: 'https://youtube.com/shorts/…',
      help: 'A YouTube video or Short. Upload it to your YouTube channel first, then paste the link.',
      validate: (v) => (youtubeId(v) ? null : 'Paste a YouTube video or Shorts link'),
    },
    { name: 'source', label: 'Source', default: 'Neural News', help: 'Shown on the video, e.g. Neural News or the channel it comes from.' },
    { name: 'category', label: 'Category', placeholder: 'World, Business, Sport…' },
    { name: 'description', label: 'Description', type: 'textarea' },
  ],
};

export default function AdminReels() {
  return <MediaContentManager config={config} />;
}
